const guiColors = {
    'motion-primary': 'oklab(0.85 0.08 0.02)',
    'motion-primary-transparent': 'oklab(0.85 0.08 0.02 / 0.75)',
    'motion-tertiary': 'oklab(0.85 0.08 0.02)',

    'looks-secondary': 'oklab(0.85 0.08 0.02)',
    'looks-transparent': 'oklab(0.85 0.08 0.02 / 0.75)',
    'looks-light-transparent': 'oklab(0.85 0.08 0.02 / 0.75)',
    'looks-secondary-dark': 'oklab(0.85 0.08 0.02)',

    'extensions-primary': 'oklab(0.85 0.08 0.02)',
    'extensions-tertiary': 'oklab(0.72 0.10 0.03)',
    'extensions-transparent': 'oklab(0.85 0.08 0.02 / 0.35)',
    'extensions-light': 'oklab(0.85 0.08 0.02)',
    
    'drop-highlight': 'oklab(0.85 0.08 0.02)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.82 -0.05 -0.15 / 0.75) 0%, ' +
        'oklab(0.85 0.08 0.02 / 0.75) 50%, ' +
        'oklab(1.0 0.0 0.0 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.85 0.08 0.02)',
    checkboxActiveBorder: 'oklab(0.85 0.08 0.02)'
};

export {
    guiColors,
    blockColors
};
